import { useContext, useEffect } from 'react';

import { Context } from '@store/store';

const useClickOutside = (ref, ignoreDataName = '') => {
  const [, dispatch] = useContext(Context);

  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current) {
        let isClickOutside, isOpened, isElementNotIgnore, ignoreElementName;

        ignoreElementName = event.target.dataset.ignoreClickOutside;

        isOpened = ref.current.dataset.isOpened === 'true';
        isClickOutside = !ref.current.contains(event.target);
        isElementNotIgnore = !(
          ignoreElementName && ignoreElementName.includes(ignoreDataName)
        );

        if (isOpened && isClickOutside && isElementNotIgnore) {
          switch (ignoreDataName) {
            case 'sidebar':
              dispatch({ type: 'CLOSE_SIDEBAR' });
              break;
            case 'bookmarks-sidebar':
              dispatch({ type: 'CLOSE_SIDEBAR' });
              break;
            case 'dropdown':
              dispatch({ type: 'CLOSE_DROPDOWN' });
              break;
            default:
          }
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
};

export default useClickOutside;
